<script setup lang="ts">
defineProps<{ gridTemplateColumns?: string }>()
</script>

<template>
  <div
    class="entities-card rounded-lg bg-white [box-shadow:var(--shadow-ring),var(--shadow-elevation)]"
    :style="gridTemplateColumns ? { '--grid-cols': gridTemplateColumns } : undefined"
  >
    <slot />
  </div>
</template>

<style scoped>
.entities-card :deep(.vtable) {
  @apply rounded-none border-0 shadow-none ring-0;
}

/* Collapse the unused accordion/caret column (no sub-rows here).
   --grid-cols is set inline on .entities-card based on visible column count. */
.entities-card :deep(.vtable__inner) {
  grid-template-columns: var(--grid-cols) !important;
}

.entities-card :deep(.vtable__caret_container) {
  padding: 0;
}

/* Roomier column gutters than v-data-table's default px-4. */
.entities-card :deep(.vtable__cell),
.entities-card :deep(.vtable__header_cell) {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

/* Let Status + Name respect their fixed grid tracks instead of growing to fit
   content (default grid min-width: auto). Truncate slots clip the rest. */
.entities-card :deep(.vtable__header > .vtable__header_cell:nth-child(2)),
.entities-card :deep(.vtable__row > .vtable__cell:nth-child(3)),
.entities-card :deep(.vtable__header > .vtable__header_cell:nth-child(3)),
.entities-card :deep(.vtable__row > .vtable__cell:nth-child(4)) {
  min-width: 0;
  overflow: hidden;
}

/* Sticky Status + Name columns only on xl+ (>=1280px). Below that the
   content area can be too narrow for two sticky columns to cohabit with
   the rest of the table, so let everything scroll inline instead. */
@media (min-width: 1280px) {
  /* Status column: header child #2 (after caret), body cell child #3 (after accent + caret). */
  .entities-card :deep(.vtable__header > .vtable__header_cell:nth-child(2)),
  .entities-card :deep(.vtable__row > .vtable__cell:nth-child(3)) {
    position: sticky;
    left: 0;
    z-index: 10;
  }

  .entities-card :deep(.vtable__row > .vtable__cell:nth-child(3)) {
    background-color: white;
  }

  .entities-card :deep(.vtable__header > .vtable__header_cell:nth-child(2)) {
    background-color: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(8px);
  }

  .entities-card :deep(.vtable__row:hover > .vtable__cell:nth-child(3)) {
    background-color: rgb(249 250 251);
  }

  /* Name column: header child #3, body cell child #4. */
  .entities-card :deep(.vtable__header > .vtable__header_cell:nth-child(3)),
  .entities-card :deep(.vtable__row > .vtable__cell:nth-child(4)) {
    position: sticky;
    left: 9rem;
    z-index: 10;
    box-shadow: 1px 0 0 0 rgb(229 231 235);
  }

  .entities-card :deep(.vtable__row > .vtable__cell:nth-child(4)) {
    background-color: white;
  }

  .entities-card :deep(.vtable__header > .vtable__header_cell:nth-child(3)) {
    background-color: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(8px);
  }

  .entities-card :deep(.vtable__row:hover > .vtable__cell:nth-child(4)) {
    background-color: rgb(249 250 251);
  }
}
</style>
